import type { ReactNode } from 'react';
import { memo, useMemo } from 'react';
import useCategoryClick from '../hooks/googleAnalytics/useCategoryClick';
import { GoogleAnalyticContext } from './GoogleAnalyticsContext';

const GoogleAnalyticsProvider = ({ children }: { children: ReactNode }) => {
    const onCategoryClick = useCategoryClick();
    const value = useMemo(
        () => ({
            onCategoryClick,
        }),
        [onCategoryClick]
    );

    return (
        <GoogleAnalyticContext.Provider value={value}>
            {children}
        </GoogleAnalyticContext.Provider>
    );
};

export default memo(GoogleAnalyticsProvider);
